import * as Dialog from "@radix-ui/react-dialog";
import { BookOpen, X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LessonDescriptionProps {
	title: string;
	description?: string;
}

export function LessonDescription({ title, description }: LessonDescriptionProps) {
	const { t } = useTranslation();
	if (!description?.trim()) return null;

	return (
		<Dialog.Root>
			<Dialog.Trigger className="flex min-h-[44px] shrink-0 items-center gap-2 rounded-md px-3 text-sm text-secondary hover:bg-bg-hover hover:text-primary">
				<BookOpen className="h-4 w-4" aria-hidden="true" />
				{t("player.aboutLesson")}
			</Dialog.Trigger>
			<Dialog.Portal>
				<Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
				<Dialog.Content
					aria-describedby={undefined}
					className="fixed inset-y-0 right-0 z-50 flex h-dvh w-full flex-col border-l border-border-subtle bg-bg-surface shadow-2xl sm:w-[420px] data-[state=open]:animate-in data-[state=open]:slide-in-from-right data-[state=closed]:animate-out data-[state=closed]:slide-out-to-right motion-reduce:animate-none"
				>
					<div className="flex shrink-0 items-start gap-4 border-b border-border-subtle p-6">
						<div className="min-w-0 flex-1">
							<p className="mb-2 text-sm text-secondary">{t("player.aboutLesson")}</p>
							<Dialog.Title className="break-words text-lg font-semibold text-primary">
								{title}
							</Dialog.Title>
						</div>
						<Dialog.Close
							aria-label={t("player.closeDescription")}
							className="flex min-h-[44px] min-w-[44px] items-center justify-center rounded-md text-secondary hover:bg-bg-hover hover:text-primary"
						>
							<X className="h-5 w-5" aria-hidden="true" />
						</Dialog.Close>
					</div>
					<div className="min-h-0 flex-1 overflow-y-auto p-6">
						<p className="whitespace-pre-wrap break-words text-sm leading-relaxed text-secondary">
							{description}
						</p>
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
}
